import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-campaign-create-dialog',
  template: `<div class="modal">
  <i class="fal fa-times modal__close" (click)="close()"></i>
  <app-campaign-create (saved)="close($event)">
  </app-campaign-create>
</div>
`
})
export class CampaignCreateDialog {
  constructor(public dialogRef: MatDialogRef<CampaignCreateDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: any) { }
  // Close dialog and pass along event data.
  close(event = null) {
    this.dialogRef.close(event);
  }
}
